export class CacheUtil {
  static clearCaches() {
    caches.keys().then(function (names) {
      for (const name of names) caches.delete(name);
    });
  }
}
